import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
export function ApiWalletPage() {
  return <DocPageLayout title="Wallet API" description="Digital wallet integration for Apple Pay, Google Pay, and other wallet providers." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Wallet'
  }]} sections={[{
    id: 'create-wallet',
    title: 'Create Wallet Payment'
  }, {
    id: 'update-wallet',
    title: 'Update Wallet'
  }]} data-id="element-752">
      <h2 id="create-wallet" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-753">
        Create Wallet Payment
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-754">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 mr-2" data-id="element-755">
          PUT
        </span>
        <span className="text-gray-600" data-id="element-756">/merchant/</span>
        <span className="text-blue-600" data-id="element-757">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-758">/order/</span>
        <span className="text-blue-600" data-id="element-759">{'{orderId}'}</span>
        <span className="text-gray-600" data-id="element-760">/transaction/</span>
        <span className="text-blue-600" data-id="element-761">{'{transactionId}'}</span>
      </div>
      <CodeBlock language="JSON" title="Apple Pay Request" code={`{
  "apiOperation": "PAY",
  "order": {
    "amount": "85.00",
    "currency": "USD"
  },
  "sourceOfFunds": {
    "type": "CARD",
    "provided": {
      "card": {
        "devicePayment": {
          "paymentToken": "{apple-pay-token-data}"
        }
      }
    }
  },
  "device": {
    "walletProvider": "APPLE_PAY"
  }
}`} data-id="element-762" />

      <h2 id="update-wallet" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-763">
        Update Wallet Session
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-764">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 mr-2" data-id="element-765">
          PUT
        </span>
        <span className="text-gray-600" data-id="element-766">/merchant/</span>
        <span className="text-blue-600" data-id="element-767">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-768">/session/</span>
        <span className="text-blue-600" data-id="element-769">{'{sessionId}'}</span>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-770">
        Supported Wallets
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-771">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-772">
          <thead data-id="element-773">
            <tr className="bg-gray-100" data-id="element-774">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-775">
                Wallet
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-776">
                Provider Value
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-777">
                Platforms
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-778">
            <tr data-id="element-779">
              <td className="px-4 py-3" data-id="element-780">Apple Pay</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-781">APPLE_PAY</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-782">
                iOS, macOS Safari, Web
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-783">
              <td className="px-4 py-3" data-id="element-784">Google Pay</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-785">GOOGLE_PAY</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-786">Android, Chrome, Web</td>
            </tr>
            <tr data-id="element-787">
              <td className="px-4 py-3" data-id="element-788">Samsung Pay</td>
              <td className="px-4 py-3 font-mono text-xs" data-id="element-789">SAMSUNG_PAY</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-790">Samsung devices</td>
            </tr>
          </tbody>
        </table>
      </div>
      <InfoBox type="tip" title="Wallet Token" data-id="element-791">
        The wallet payment token is a one-time-use encrypted payload provided by
        the wallet SDK. It must be used immediately and cannot be stored for
        later use.
      </InfoBox>
    </DocPageLayout>;
}